import { Radio } from "antd";
import React, { useState } from "react";
import {
  relationOption,
  yesNoOptions,
} from "../../../../Helpers/InterBranchConstants";
import Dropdown from "../../../DropDown/Dropdown";
import './lifestyleandpreexisting.css'

function LifestyleAndPreExistingConditionsPatient() {
  let [formData, setFormData] = useState({
    alcohol: "",
    smoke: "",
    exercise: "",
    sleep: "",
    travel: "",
    anemiaSelf: "",
    anemiaFamily: "",
    asthmaSelf: "",
    asthmaFamily: "",
    diabetesSelf: "",
    diabetesFamily: "",
    cholesterolSelf: "",
    cholesterolFamily: "",
    thyroidDiseaseSelf: "",
    thyroidDiseaseFamily: "",
    heartDiseaseSelf: "",
    heartDiseaseFamily: "",
    strokeSelf: "",
    strokeFamily: "",
    glaucomaSelf: "",
    glaucomaFamily: "",
    highBloodPressureSelf: "",
    highBloodPressureFamily: "",
    cancerSelf: "",
    cancerFamily: "",
    tuberculosisSelf: "",
    tuberculosisFamily: "",
    allergiesSelf: "",
    allergiesFamily: "",
  });

  const handleChangeFormItemLifestyle = () => {};
  const validateDataForFields = () => {};
  
  let handleChangeFormItem = ({ key, value, owner }) => {
   

}

  return (
    <div className="lsapec-container">
      <div className="tables-container">
        <div className="table-container">
          <div className="tittle">Lifestyle</div>

          <table className="lpec-table">
            <tr>
              <th colSpan={3}>Conditions</th>
            </tr>

            <tbody>
              <tr>
                {/* <td>Blood Pressure</td>                             

                                <td>
                                    <Radio.Group name={formData.highbp} value={formData.highbp}>

                                        <Radio value={"Yes"}  onClick={(e) => { handleChangeFormItem({ key: "highbp", value: "Yes"}) }}>Yes</Radio>

                                        <Radio value={"No"}  onClick={(e) => { handleChangeFormItem({ key: "highbp", value: "No" }) }}>No</Radio>
                                    </Radio.Group>
                                </td> */}
              </tr>

              <tr>
                <td>Alcohol</td>

                <td>
                  <Radio.Group name={formData.alcohol} value={formData.alcohol}>
                    <Radio
                      value={"Yes"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "alcohol",
                          value: "Yes",
                        });
                      }}
                    >
                      Yes
                    </Radio>

                    <Radio
                      value={"No"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "alcohol",
                          value: "No",
                        });
                      }}
                    >
                      No
                    </Radio>
                  </Radio.Group>
                </td>
              </tr>

              <tr>
                <td>Exercise</td>

                <td>
                  <Radio.Group
                    name={formData.exercise}
                    value={formData.exercise}
                  >
                    <Radio
                      value={"Yes"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "exercise",
                          value: "Yes",
                        });
                      }}
                    >
                      Yes
                    </Radio>

                    <Radio
                      value={"No"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "exercise",
                          value: "No",
                        });
                      }}
                    >
                      No
                    </Radio>
                  </Radio.Group>
                </td>
              </tr>

              <tr>
                <td>Sleep</td>

                <td>
                  <Radio.Group name={formData.sleep} value={formData.sleep}>
                    <Radio
                      className="mr-2"
                      value={"Yes"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "sleep",
                          value: "Yes",
                        });
                      }}
                    >
                      Yes
                    </Radio>

                    <Radio
                      value={"No"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "sleep",
                          value: "No",
                        });
                      }}
                    >
                      No
                    </Radio>
                  </Radio.Group>
                </td>
              </tr>

              <tr>
                <td>Smoke</td>

                <td>
                  <Radio.Group name={formData.smoke} value={formData.smoke}>
                    <Radio
                      value={"Yes"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "smoke",
                          value: "Yes",
                        });
                      }}
                    >
                      Yes
                    </Radio>

                    <Radio
                      value={"No"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "smoke",
                          value: "No",
                        });
                      }}
                    >
                      No
                    </Radio>
                  </Radio.Group>
                </td>
              </tr>

              <tr>
                <td>Travel</td>

                <td>
                  <Radio.Group name={formData.travel} value={formData.travel}>
                    <Radio
                      className="mr-2"
                      value={"Yes"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "travel",
                          value: "Yes",
                        });
                      }}
                    >
                      Yes
                    </Radio>

                    <Radio
                      value={"No"}
                      onClick={(e) => {
                        handleChangeFormItemLifestyle({
                          key: "travel",
                          value: "No",
                        });
                      }}
                    >
                      No
                    </Radio>
                  </Radio.Group>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-container">
          <div className="tittle">Pre-Exisiting Conditions</div>

          <table className="lifestyle-table ">
            <tr>
              <th>Conditions</th>
              <th>For Self</th>
              <th>In Family</th>
            </tr>

            <tbody>
              <tr>
                <td>Allergies</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.allergiesSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "allergies",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.allergiesFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "allergies",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>Anemia</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.anemiaSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "anemia",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.anemiaFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "anemia",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>

              <tr>
                <td>Asthma</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.asthmaSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "asthma",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.asthmaFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "asthma",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>

              <tr>
                <td>Cancer</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.cancerSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "cancer",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.cancerFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "cancer",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>Cholesterol</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.cholesterolSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "cholesterol",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.cholesterolFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "cholesterol",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>Diabetes</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.diabetesSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "diabetes",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.diabetesFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "diabetes",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>Glaucoma</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.glaucomaSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "glaucoma",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.glaucomaFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "glaucoma",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>

              <tr>
                <td>Heart Disease</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.heartDiseaseSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "heartDisease",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.heartDiseaseFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "heartDisease",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>High Blood Pressure</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(
                      formData.highBloodPressureSelf
                    )}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "highBloodPressure",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(
                      formData.highBloodPressureFamily
                    )}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "highBloodPressure",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
              <tr>
                <td>Stroke</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.strokeSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "stroke",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.strokeFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "stroke",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>

              <tr>
                <td>Thyroid Disease</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.thyroidDiseaseSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "thyroidDisease",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.thyroidDiseaseFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "thyroidDisease",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>

              <tr>
                <td>Tuberculosis</td>

                <td>
                  <Dropdown
                    width={121}
                    data={yesNoOptions}
                    placeholder="Select"
                    value={validateDataForFields(formData.tuberculosisSelf)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "tuberculosis",
                        owner: "Self",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>

                <td>
                  <Dropdown
                    width={121}
                    data={relationOption}
                    placeholder="Select"
                    value={validateDataForFields(formData.tuberculosisFamily)}
                    onChange={(e) => {
                      handleChangeFormItem({
                        key: "tuberculosis",
                        owner: "Family",
                        value: e,
                      });
                    }}
                    isV2
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="button-container">
        <button className="submt-btn">SAVE</button>
      </div>
    </div>
  );
}

export default LifestyleAndPreExistingConditionsPatient;
